import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { QuizQuestion, QuizQuestionValue } from '../models';

export const quizQuestionActions = createActionGroup({
    source: 'QuizQuestion',
    events: {
        'Get Quiz Question': props<{ id: string }>(),
        'Get Quiz Question Success': props<{ payload: QuizQuestion }>(),
        'Get Quiz Question Error': props<{ code: number; id: string }>(),
        'Create Quiz Question': props<{ value: QuizQuestionValue }>(),
        'Create Quiz Question Success': props<{ payload: QuizQuestion }>(),
        'Create Quiz Question Error': props<{ code: number }>(),
        'Update Quiz Question': props<{ id: string; value: QuizQuestionValue }>(),
        'Update Quiz Question Success': props<{ payload: QuizQuestion }>(),
        'Update Quiz Question Error': props<{ code: number }>(),
        'Delete Quiz Question': props<{ id: string }>(),
        'Delete Quiz Question Success': props<{ id: string }>(),
        'Delete Quiz Question Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
